import { inlineJsonMarker } from './inlineJsonMarker'

export const EMAIL_STAGED_DRAFT_CARD_MARKER = '__EMAIL_STAGED_DRAFT_CARD__'

export type EmailStagedDraftPayload = {
  draft_key: string
  subject: string
  to?: string
  cc?: string
  body_html: string
  preview?: string
  source_message_id: string
  source_conversation_id: string
}

const emailStagedDraftCardMarker = inlineJsonMarker<EmailStagedDraftPayload>(
  EMAIL_STAGED_DRAFT_CARD_MARKER,
)

export const parseEmailStagedDraftCard = emailStagedDraftCardMarker.parse
export const splitEmailStagedDraftCard = emailStagedDraftCardMarker.split
